import React from 'react';

const Card = ({
  children,
  variant = 'default',
  hover = true,
  className = '',
  ...props
}) => {
  // raio 6px (card/painel), per escala de raio da identidade visual v1.5
  const baseStyles = 'rounded-md shadow-lg transition-all duration-300';
  
  const variants = {
    default: 'bg-rn-surface border border-rn-line',
    primary: 'on-navy bg-rn-navy-surface text-white',
    featured: 'on-navy bg-rn-navy-surface border-4 border-rn-orange text-white',
    subtle: 'bg-rn-bg border-2 border-transparent',
  };
  
  const hoverStyles = hover ? 'hover:scale-105 hover:shadow-xl' : '';
  const variantClasses = variants[variant];
  
  return (
    <div
      className={`${baseStyles} ${variantClasses} ${hoverStyles} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;